module.exports = __webpack_public_path__ + "media/media/product-card/vlsat-pro-b8708b47bfca421cf29c1ffe19490841.jpg";